import {FillPattern} from "exceljs";
import {mutateColorToExcelJsFormat} from './color'
import {IExportExcelStylesFill} from "@containers/export/containers/excel/types";

export const mutateFillToExcelJsFormat = (fill: IExportExcelStylesFill): FillPattern | undefined => {
    if (!fill?.fgColor?.rgb) {
        return
    }

    return {
        type: 'pattern',
        pattern: 'solid',
        fgColor: mutateColorToExcelJsFormat(fill.fgColor)
    }
}